<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.commonterms.name')" maxlength="512"
          :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="12" class="mt-3">
        <QTextArea v-model="item.Description" :label="$t('servicesystem.common_objects.commonterms.description')"
          :externaledit="editMode" clearable @FocusState="handleFocus">
        </QTextArea>
      </v-col>
      <v-col cols="12" class="mt-3">
        <CustomerSelect v-model="item.CustomerId" :externaledit="editMode">
        </CustomerSelect>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";

export default {
  name: "UnitEditContent",
  props: {
    item: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    CustomerSelect
  },
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
  },

  computed: {
  },

  watch: {},
};
</script>


<style lang='scss'></style>